/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ThirdPartyNetwork } from '../../models/third-party-network';

export interface ApiMasterThirdPartyNetworkGetAllGet$Params {
}

export function apiMasterThirdPartyNetworkGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterThirdPartyNetworkGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ThirdPartyNetwork>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterThirdPartyNetworkGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ThirdPartyNetwork>>;
    })
  );
}

apiMasterThirdPartyNetworkGetAllGet.PATH = '/api/Master/ThirdPartyNetwork/GetAll';
